module.exports = __webpack_public_path__ + "static/img/njwxBg.73c5a7bb.png";